import { render, staticRenderFns } from "./WooCommerce.vue?vue&type=template&id=96288ffa&"
import script from "./WooCommerce.vue?vue&type=script&lang=ts&"
export * from "./WooCommerce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports